export default __webpack_public_path__ + "static/media/banner-welcome.2ec8e38f.jpg";